import { type ChallengeOptInV2Mutation } from '../../../../graphql/operations.generated';

export const checkIfChallengeStarted = (
  result?: ChallengeOptInV2Mutation,
): boolean => {
  if (!result) return false;

  if (result.challengeOptInV2.__typename === 'LoyaltyOptInFailed') return false;

  return result.challengeOptInV2.status === 'STARTED';
};
